import React from "react";
import { Link } from "react-router-dom";

const SiteFooter = ({ t }) => {
  return (
    <>
      <footer className="home-footer">
        <div className="home-container footer-inner">
          <span className="footer-brand">Cargotronics</span>
          <div className="footer-links">
            <Link className="footer-link" to="/politicas-privacidad">
              {t.footer.politicas}
            </Link>
            <Link className="footer-link" to="/gdpr">
              {t.footer.gdpr}
            </Link>
            <Link className="footer-link" to="/terminos-condiciones">
              {t.footer.terminos}
            </Link>
          </div>
          <span className="footer-legal">{t.footer.legal}</span>
        </div>
      </footer>

     
    </>
  );
};

export default SiteFooter;
